import Lottie from 'lottie-react';
import { FolderX } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import animationData from '../../../../assets/json/loader.json';

interface IdeViewI {
    isLoading: boolean;
    isError: boolean;
}

const IdeView: FC<IdeViewI> = ({ isLoading, isError }) => {
    const { t } = useTranslation();
    return (
        <div className="flex h-full w-full min-h-[inherit] justify-center items-center mt-auto mb-auto">
            {isLoading && <Lottie animationData={animationData} loop={true} />}
            {isError && (
                <div className="flex flex-col items-center justify-center">
                    <FolderX className="h-24 w-24 mb-4" />
                    <p>{t('errors.generic')}</p>
                </div>
            )}
        </div>
    );
};

export default IdeView;
